import React from 'react';
import { useIntl } from 'react-intl';

import styles from './styles.module.scss';

interface IProps {
  children: React.ReactNode;
}

/**
 * Wraps the header's own navigation menu in the mobile drawer and shows its links as bubbles under
 * "Explore". The menu component (links, external / sibling handling, submenus) is unchanged; only
 * its look is scoped here.
 */
export const AccountMenuExplore = ({ children }: IProps): React.ReactElement => {
  const intl = useIntl();

  return (
    <section className={styles.explore} aria-label={intl.formatMessage({ id: 'my.account.hub.menu.explore' })}>
      <span className={styles.exploreTitle} aria-hidden="true">{intl.formatMessage({ id: 'my.account.hub.menu.explore' })}</span>
      {children}
    </section>
  );
};
